/**
 * Domain constants for Google Trends.
 * These domains correspond to Google Trends categories and are used across the application.
 * Must match pars/constants/domains.py
 * 
 * IMPORTANT: This is the source of truth for frontend. Backend uses pars/constants/domains.py
 * 
 * Supported domains:
 * - Sports, Entertainment, Politics, Business, News, Technology, Science, Health, 
 *   Education, Food, Travel, Gaming, Other
 * - Environment and Finance are also included for Google Trends filtering
 */

const DOMAINS = [
  { value: 'all', label: 'Все сегменты' },
  { value: 'Entertainment', label: 'Развлечения' },
  { value: 'Sports', label: 'Спорт' },
  { value: 'Technology', label: 'Технологии' },
  { value: 'Health', label: 'Здоровье' },
  { value: 'Environment', label: 'Окружающая среда' },
  { value: 'Finance', label: 'Финансы' },
  { value: 'Politics', label: 'Политика' },
  { value: 'Science', label: 'Наука' },
  { value: 'Gaming', label: 'Игры' },
  { value: 'News', label: 'Новости' },
  { value: 'Business', label: 'Бизнес' },
  { value: 'Education', label: 'Образование' },
  { value: 'Travel', label: 'Путешествия' },
  { value: 'Food', label: 'Еда' },
  { value: 'Other', label: 'Другое' },
];

/**
 * Get domain label by value
 * @param {string} value - Domain value
 * @returns {string} Domain label or value if not found
 */
export const getDomainLabel = (value) => {
  const domain = DOMAINS.find(d => d.value === value);
  return domain ? domain.label : value;
};

/**
 * Check if domain value is valid
 * @param {string} domain - Domain value to check
 * @returns {boolean} True if domain is valid
 */
export const isValidDomain = (domain) => {
  if (domain === 'all') {
    return true;
  }
  return DOMAINS.some(d => d.value === domain);
};

export { DOMAINS }; 